import { IResource, ISchedule } from "@gettactic/api";
import { VirtualizedList } from "@v2/components/display/VirtualizedList/VirtualizedList";
import { ResourceLabel } from "@v2/components/labels/ResourceLabel/ResourceLabel";
import { MapFiltersCardSearchNoResults } from "@webV2/components/cards/MapFiltersCard/MapFiltersCardSearchNoResults";
import { MapFiltersCardClasses as classes } from "@webV2/components/cards/MapFiltersCard/MapFiltersCard";

export interface ResourceWithSchedules extends IResource {
  schedules?: ISchedule[];
}

export interface GetResourcesVirtualizedListTabOptions {
  value: string;
  label: string;
  resources: ResourceWithSchedules[];
  setResourceIdHovering: (resourceId: IResource | null) => void;
  onReserve: (resourceId: IResource | null) => void;
  searchText?: string;
  showSchedules?: boolean;
  showScheduleOfUserId?: string | undefined;
  floorName?: string;
}

export const getResourcesVirtualizedListTab = (
  options: GetResourcesVirtualizedListTabOptions
) => {
  const {
    value,
    label,
    resources,
    setResourceIdHovering,
    onReserve,
    searchText = "",
    showSchedules = false,
    showScheduleOfUserId,
    floorName
  } = options;

  const isOther = label === "Other";

  return {
    value,
    label,
    content: !resources.length ? (
      searchText.length > 0 ? (
        <MapFiltersCardSearchNoResults 
          target={isOther ? "resources" : String(label).toLowerCase()} 
          searchText={searchText}
          floorName={floorName}
        />
      ) : (
        <div className="text-center text-gray-500 text-md">
          {getPlaceholderText(isOther ? "other resources" : label)}
        </div>
      )
    ) : (
      <VirtualizedList
        itemHeight={88}
        scrollAreaProps={{
          className: "!absolute inset-0"
        }}
      >
        { resources.map((resource) => {
          const schedules = showSchedules
            ? showScheduleOfUserId
              ? resource.schedules?.filter((schedule) => {
                  return schedule.slots?.some(
                    (slot) => slot.user?.id === showScheduleOfUserId
                  );
                })
              : resource.schedules
            : undefined;

          return (
            <ResourceLabel
              className={classes.ListItem}
              resource={resource}
              key={resource.id}
              onMouseEnter={() => {
                setResourceIdHovering(resource);
              }}
              onClick={() => onReserve(resource)}
              onMouseLeave={() => setResourceIdHovering(null)}
              schedules={schedules}
              showHierarchy={!schedules?.length}
            />
          );
        })}
      </VirtualizedList>
    ),
    className: classes.TabsContent
  };
};

export const getPlaceholderText = (contentType: string) => {
  return `No ${contentType} found on this floor for the selected date and time.`;
};
